import actionTypes from './actionTypes'

const interactiveVideoActions = {
	videoStorePickerInitialized: params => ({
		type: actionTypes.VIDEO_STORE_PICKER_INITIALIZED,
		params,
	}),

	videoStorePickerUpdated: params => ({
		type: actionTypes.VIDEO_STORE_PICKER_UPDATED,
		params,
	}),

	videoStoreLessonSelected: lessonUID => ({
		type: actionTypes.VIDEO_STORE_LESSON_SELECTED,
		lessonUID,
	}),

	videoStoreLessonCopiedSuccess: () => ({
		type: actionTypes.VIDEO_STORE_LESSON_COPIED_SUCCESS,
	}),

	videoStoreLessonCopiedFailed: (serverError, upgradeSource) => ({
		type: actionTypes.VIDEO_STORE_LESSON_COPIED_FAILED,
		serverError,
		upgradeSource,
	}),

	myVideosLessonSelected: lessonUID => ({
		type: actionTypes.VIDEO_MY_VIDEOS_LESSON_SELECTED,
		lessonUID,
	}),

	myVideosPickerInitialized: () => ({
		type: actionTypes.VIDEO_MY_VIDEOS_PICKER_INITIALIZED,
	}),

	myVideosPickerFinalized: () => ({
		type: actionTypes.VIDEO_MY_VIDEOS_PICKER_FINALIZED,
	}),

	saveVideo: () => ({
		type: actionTypes.VIDEO_SAVE,
	}),

	saveVideoSuccess: () => ({
		type: actionTypes.VIDEO_SAVE_SUCCESS,
	}),

	saveVideoFailed: error => ({
		type: actionTypes.VIDEO_SAVE_FAILED,
		error,
	}),

	cancel: () => ({
		type: actionTypes.VIDEO_CANCEL,
	}),

	cancelConfirmed: () => ({
		type: actionTypes.VIDEO_CANCEL_CONFIRMED,
	}),

	cancelRejected: () => ({
		type: actionTypes.VIDEO_CANCEL_REJECTED,
	}),

	onQuerySearchSelected: query => ({
		type: actionTypes.VIDEO_MY_VIDEOS_PICKER_QUERY_SEARCH,
		query,
	}),

	getLessonsNextPage: () => ({
		type: actionTypes.VIDEO_MY_VIDEOS_GET_LESSONS_NEXT_PAGE,
	}),

	copyFailed: () => ({
		type: actionTypes.VIDEO_COPY_FAILED,
	}),

	handoutSelected: handoutType => ({
		type: actionTypes.VIDEO_HANDOUT_SELECTED,
		handoutType,
	}),

}

export default interactiveVideoActions
